import React, { useEffect } from 'react';

export const ImagePreview = ({ imageUrl, onClose }) => {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                e.preventDefault();
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape, true);

        return () => document.removeEventListener('keydown', handleEscape, true);
    }, [onClose]);

    if (!imageUrl) return null;

    return (
        <div
            className="accent-image-preview-overlay"
            onClick={onClose}
            onKeyDown={(e) => {
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    e.preventDefault();
                }
            }}
        >
            <div className="accent-image-preview-container">
                <img
                    src={imageUrl}
                    alt="Preview"
                    className="accent-image-preview"
                    onClick={(e) => e.stopPropagation()}
                />
                <button
                    className="accent-image-preview-close"
                    onClick={onClose}
                    aria-label="Close preview"
                >
                    ×
                </button>
            </div>
        </div>
    );
};